var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Story/Transparent - WithoutCircle",
    clipPath: "url(#clip0_577_171098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Story"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M128.772 154.184C137.165 143.988 162.924 132.017 182.996 132.017",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M73.7321 129.636C99.3114 128.934 120.907 144.104 127.128 153.894",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M131.352 153.706C143.439 145.17 171.724 138.3 191.389 142.559",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.0775 142.886C85.226 136.755 114.219 143.867 126.54 153.591",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M135.059 173.583C148.724 168.288 170.32 167.579 188.491 173.716C190.501 174.395 192.6 173.177 192.6 171.039V158.765C192.6 157.626 191.893 156.705 190.933 156.105C180.879 149.798 154.591 147.484 134.585 154.324C134.087 154.494 133.553 154.554 133.025 154.554H122.053C121.537 154.56 121.033 154.469 120.542 154.306C108.136 150.095 79.707 148.617 64.9316 156.263C63.8398 156.826 63 157.801 63 159.043V171.578C63 173.595 65.0276 175.189 66.8513 174.365C81.3507 167.822 102.005 166.871 120.572 173.529C121.015 173.686 121.477 173.783 121.945 173.783H133.745C134.195 173.783 134.639 173.747 135.059 173.583Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M133.211 155.214V173.098",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M122.113 172.741V154.548",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M99.9713 111.746C94.7342 96.4551 100.433 84.8413 118.178 82",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M107.644 109.717C102.245 99.2964 108.814 90.7663 119.702 90.1969",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M139.348 106.463L151.154 113.739C152.288 114.442 152.648 115.939 151.958 117.084L145.443 127.861C144.747 129.006 143.265 129.37 142.132 128.673L130.356 121.421C129.81 121.082 129.15 120.979 128.532 121.137L111.387 125.347C109.3 125.862 107.638 123.566 108.76 121.712L129.366 87.5979C130.47 85.7743 133.193 86.1681 133.751 88.2279L138.274 105.021C138.436 105.621 138.82 106.136 139.342 106.463H139.348Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_171098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/Story.8e192d46be9e8d8324dfe644258bb2ef.svg";
export { ForwardRef as ReactComponent };